module.exports = __webpack_public_path__ + "img/wave2.dc9106cf.png";